import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBook = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-book';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.25 10.87c.011 7.307.014 7.641.086 7.89.041.143.126.376.19.517.353.785 1.135 1.318 2.118 1.441.222.028 2.811.042 7.725.042h7.391V7.17l-2.13-1.865L16.5 3.44l-.248.27-.249.27-.001-.37L16 3.24H3.238zm2.99-3.39c0 1.496.009 2.72.02 2.72s.632-.306 1.38-.68L9 8.84l1.36.68c.748.374 1.369.68 1.38.68s.02-1.224.02-2.72V4.76h3.48v14.481l-4.81-.01-4.81-.011-.2-.092a1.04 1.04 0 0 1-.547-.543l-.093-.205-.01-6.81-.011-6.81H6.24zm4-1.22c0 .825-.009 1.5-.02 1.5s-.291-.135-.62-.3L9 7.159l-.6.301c-.329.165-.608.3-.62.3-.011 0-.02-.675-.02-1.5v-1.5h2.48zm7.875.58 1.122.98.001 5.71.002 5.71h-2.48V5.674l.116.093c.064.051.621.534 1.239 1.073M6.498 12.291c-.011.029-.015.366-.009.75l.011.699h7v-1.48l-3.491-.01c-2.822-.008-3.495-.001-3.511.041m0 3c-.011.029-.015.366-.009.75l.011.699h7v-1.48l-3.491-.01c-2.822-.008-3.495-.001-3.511.041"
    })
  }));
});
export default SvgBook;